exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* explorer */\n/* actionbar */\n@font-face {\n  font-family: 'cat';\n  src: url(\"/assets/fonts/cat.eot?vcfb5d\");\n  src: url(\"/assets/fonts/cat.eot?vcfb5d#iefix\") format(\"embedded-opentype\"), url(\"/assets/fonts/cat.ttf?vcfb5d\") format(\"truetype\"), url(\"/assets/fonts/cat.woff?vcfb5d\") format(\"woff\"), url(\"/assets/fonts/cat.svg?vcfb5d#cat\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n:host .btn {\n  border-color: #ddd;\n  border-style: solid;\n  border-width: 0;\n  margin-top: 0;\n  margin-right: 0;\n  margin-bottom: 0;\n  margin-left: 0;\n  padding-top: 0.5rem;\n  padding-right: 1rem;\n  padding-bottom: 0.5rem;\n  padding-left: 1rem;\n  background: #F1F0F0; }\n\n:host .success {\n  color: #ffffff;\n  font-weight: bold;\n  background: #00bba6; }\n\n:host .warning {\n  color: #ffffff;\n  font-weight: bold;\n  background: #fdc708; }\n\n:host .alert {\n  color: #ffffff;\n  font-weight: bold;\n  background: #ff544d; }\n\n:host .active {\n  background: lime; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/button/button.component.scss
// module id = ../../../../../src/app/modules/ui-base/components/button/button.component.scss
// module chunks = main